/**
 * Buy Together Upsell Logic - Optimized for GA4 & Performance
 * 优化重点：标准电子商务事件、事件委托、健壮性
 */

// 封装 GA4 发送函数，增加容错
const sendGA4Event = (eventName, params) => {
    if (typeof window.gtag === 'function') {
        gtag('event', eventName, params);
    } else {
        console.warn(`[GA4] gtag not found, event ${eventName} skipped.`);
    }
};

window.dispatchCustomEvent = function(name, detail = {}) {
    document.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true
    }));
};

const showSuccessModal = (title, img) => {
    const modal = document.getElementById('bt-success-modal');
    if (!modal) return;
    const t = modal.querySelector('.bt-modal-product-title');
    const i = modal.querySelector('.bt-modal-product-image');
    if (t) t.textContent = title;
    if (i) { i.src = img; i.alt = title; }
    modal.classList.add('active');
};

const closeModal = () => {
    const modal = document.getElementById('bt-success-modal');
    modal?.classList.remove('active');
};

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('buy-together-upsell-container');
    if (!container) return;

    // --- 1. 核心逻辑：加入购物车处理 ---
    const handleAddToCart = async (e) => {
        // 这里的 e.target 是 form 元素
        const form = e.target;
        const btn = form.querySelector('button[type="submit"]');
        const originalText = btn.textContent;
        
        btn.textContent = 'Adding...'; 
        btn.disabled = true;
        
        try {
            // 获取数据 (优先尝试 dataset，提高稳定性)
            const formData = new FormData(form);
            const variantId = formData.get('id');
            // 假设 input 中有 quantity，没有则默认为 1
            const quantity = parseInt(formData.get('quantity') || 1); 
            const productTitle = formData.get('product-title');
            const productPrice = parseFloat(formData.get('product-price') || 0);
            const currency = formData.get('currency') || 'USD';
            const productImage = formData.get('product-image');

            // 发起请求
            const res = await fetch('/cart/add.js', { 
                method: 'POST', 
                body: formData, 
                headers: { 'X-Requested-With': 'XMLHttpRequest' } 
            });
            
            if(!res.ok) throw new Error('Error adding to cart');
            const item = await res.json();

            // 为了 UI 体验稍微延迟 (可选，通常建议移除以加快响应，这里保留您的逻辑但缩短时间)
            // await new Promise(r => setTimeout(r, 100)); 

            // --- GA4 优化部分 ---
            // "Add to Cart" 是漏斗的中部。确保 Value 准确。
            sendGA4Event('add_to_cart', {
                currency: currency,
                value: productPrice * quantity, // 总价值 = 单价 * 数量
                items: [{
                    item_id: variantId,
                    item_name: productTitle,
                    price: productPrice,
                    quantity: quantity,
                    item_list_name: 'Buy Together Recommendation',
                    item_list_id: 'buy_together_upsell' // 建议添加 ID
                }]
            });
            
            // 自定义事件 (保留用于您内部的特定分析)
            sendGA4Event('buy_together_add', {
                event_category: 'Ecommerce',
                event_label: productTitle
            });
            // --------------------
            
            // UI 更新
            showSuccessModal(productTitle, productImage);
            // 触发 Shopify 常见的购物车更新事件
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item }, bubbles: true }));
            // 触发自定义事件
            window.dispatchCustomEvent('cart:refresh');

        } catch(err) {
            console.error("Add to cart failed:", err);
            // 这里可以添加错误提示给用户
        } finally {
            btn.textContent = originalText; 
            btn.disabled = false;
        }
    };

    // --- 2. 初始化轮播 (Slider) ---
    const initSlider = () => {
        const btSlider = container.querySelector('.bt-slider-container');
        if(!btSlider) return;

        const btTrack = btSlider.querySelector('.bt-slider-track');
        if(!btTrack) return;

        const btSlides = Array.from(btTrack.children);
        if (btSlides.length <= 1) {
            // 如果只有一张图，隐藏箭头
            btSlider.querySelectorAll('[class^="bt-slider-btn"]').forEach(b => b.style.display = 'none');
            return;
        }

        let btCurIdx = 0;
        const updateBtSlide = () => {
            btTrack.style.transform = `translateX(-${btCurIdx * 100}%)`;
        };

        // 使用事件委托处理 Slider 按钮，避免多次绑定
        btSlider.addEventListener('click', (e) => {
            const btn = e.target.closest('button');
            if (!btn) return;

            if (btn.classList.contains('bt-slider-btn--next')) {
                btCurIdx = (btCurIdx + 1) % btSlides.length; 
                updateBtSlide();
            } else if (btn.classList.contains('bt-slider-btn--prev')) {
                btCurIdx = (btCurIdx - 1 + btSlides.length) % btSlides.length; 
                updateBtSlide();
            }
        });
    };

    // --- 3. 全局事件委托 (替代 cloneNode 和单独绑定) ---
    // 这是性能更好且代码更简洁的做法
    const initGlobalDelegation = () => {
        container.addEventListener('click', (e) => {
            // 处理 "Choose Options" 点击 (Select Item)
            const chooseBtn = e.target.closest('.bt-choose-options-button');
            if (chooseBtn) {
                e.preventDefault();
                const handle = chooseBtn.dataset.productHandle;
                
                // --- GA4: 使用标准的 select_item ---
                sendGA4Event('select_item', {
                    item_list_name: 'Buy Together Recommendation',
                    item_list_id: 'buy_together_upsell',
                    items: [{
                        item_id: handle, // 或者具体的 ID
                        item_name: handle // 如果有 title 更好，这里用 handle 代替
                    }]
                });
                
                location.href = `/products/${handle}`;
                return;
            }
        });

        // 处理 Add To Cart 表单提交
        // 使用 capture 阶段或在 container 上监听 submit 并不总是有效(submit 不冒泡，但 HTML5 中通常会处理)
        // 最稳妥的方式仍然是监听 document 的 submit，或者给 button click 绑定。
        // 您之前的 document 监听方式是可行的，这里保持原样但逻辑解耦。
    };

    // 绑定全局 Submit (因为 form submit 事件会冒泡)
    document.addEventListener('submit', (e) => {
        // 检查是否是我们组件内的表单
        if(e.target.matches('#buy-together-upsell-container .bt-add-to-cart-form')) {
            e.preventDefault();
            handleAddToCart(e);
        }
    });

    // Modal 交互
    const modal = document.getElementById('bt-success-modal');
    if(modal) {
        modal.addEventListener('click', (e) => {
            if (e.target === modal || e.target.closest('.bt-modal-close') || e.target.closest('.bt-modal-continue')) {
                closeModal();
            } else if (e.target.closest('.bt-modal-cart')) {
                location.href = '/cart';
            }
        });
    }

    // 执行初始化
    initSlider();
    initGlobalDelegation();
});